<template>
    <c-dialog ref="dialog" title="采购退货详情" mode="slide" width="80vw" enable-flex mask-close>
        <template #head>
            <div v-if="detailData.return_code" class="m-detail-tag flex-center-cross">
                <label>{{detailData.return_code}}</label>
                <c-state tag async dict="PURCHASE_RETURN_STATE" :value="detailData.return_state"></c-state>
            </div>
        </template>

        <module>
            <module-col size="400">
                <c-detail class="m-detail-form">
                    <c-detail-item label="采购退货单号">{{detailData.return_code || '-'}}</c-detail-item>
                    <c-detail-item label="关联单据">{{detailData.purchase_code || '-'}}</c-detail-item>
                    <c-detail-item label="退货数">{{detailData.return_count || 0}}</c-detail-item>
                    <c-detail-item label="退货人">{{detailData.returnee_name || '-'}}</c-detail-item>
                    <c-detail-item label="退货人手机号">{{detailData.returnee_phone || '-'}}</c-detail-item>
                    <c-detail-item label="退货地址">{{detailData.returnee_address || '-'}}</c-detail-item>
                    <c-detail-item label="退货快递单号">{{detailData.express_no || '-'}}</c-detail-item>
                    <c-detail-item label="申请人">{{detailData.apply_user_realname || '-'}}</c-detail-item>
                    <c-detail-item label="申请时间">{{detailData.create_date || '-'}}</c-detail-item>
                    <c-detail-item label="操作人">{{detailData.operator_user_realname || '-'}}</c-detail-item>
                    <c-detail-item label="备注">{{detailData.remark || '-'}}</c-detail-item>
                </c-detail>
            </module-col>

            <module-col tab-type="border-tab">
                <module-tab name="退货产品" enable-flex>
                    <div class="m-detail-box">
                        <c-table :data="productList" border :paging="false">
                            <c-table-column label="分类" width="80">
                                <template #default="{data}">{{data.category_name || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="品牌" width="80">
                                <template #default="{data}">{{data.brand_name || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="机型" width="110">
                                <template #default="{data}">{{data.spu_model_name || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="内存" width="80">
                                <template #default="{data}">{{data.memory_name || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="颜色" width="90">
                                <template #default="{data}">{{data.color_name || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="背贴码" width="150">
                                <template #default="{data}">{{data.produce_unique_code || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="IMEI" width="150">
                                <template #default="{data}">{{data.produce_imei || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="等级" width="80">
                                <template #default="{data}">{{data.level_name || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="采购报价" width="100">
                                <template #default="{data}">￥{{data.purchase_price || 0}}</template>
                            </c-table-column>
<!--                            <c-table-column label="退货货款" width="100">-->
<!--                                <template #default="{data}">￥{{data.return_money || 0}}</template>-->
<!--                            </c-table-column>-->
                            <c-table-column label="外部订单号" width="130">
                                <template #default="{data}">{{data.out_order_number || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="备注" width="150">
                                <template #default="{data}">{{data.remark || '-'}}</template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
        </module>

        <template #button>
            <c-button v-if="Number(detailData.return_state) === 1" size="dialog" @click="editReturnInfo">修改退货信息</c-button>
            <c-button v-if="Number(detailData.return_state) === 1" size="dialog" color="main" @click="confirmReturn">确认退货</c-button>
        </template>
    </c-dialog>
</template>

<script>
export default {
    name: 'purchaseReturnDetail',

    props: {
        id: [String, Number]
    },

    data() {
        return {
            purchase_return_order_id: 0,
            detailData: {},
            productList: []
        }
    },

    methods: {
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },

        detail() {
            this.request({
                url: '/purchase/return/detail',
                data: {
                    purchase_return_order_id: this.purchase_return_order_id
                },
                loading: true,
                success: data => {
                    this.detailData = data.detailInfo || {};
                    this.productList = data.productList || [];
                }
            });
        },

        open() {
            this.purchase_return_order_id = this.id;
            this.detail();
            this.$refs.dialog.open();
        },

        editReturnInfo() {
            this.globalDialog('purchaseReturnEdit', {
                data: {
                    returnOrder: this.detailData
                }
            }, () => {
                this.detail();
                this.$emit('resolve');
            });
        },

        confirmReturn() {
            this.globalDialog('purchaseReturnConfirm', {
                data: {
                    returnOrders: [this.detailData]
                }
            }, () => {
                this.detail();
                this.$emit('resolve');
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.return-state {
    margin-left 10px
    padding 2px 7px
    border-radius 2px
    font-size 12px
    line-height 18px
}

.is-pending {
    color #4775ff
    background #eff3ff
}

.is-returned {
    color #777
    background #f5f5f5
}
</style>
